export enum WorkshopSectionType {
  copy = 'copy',
  image = 'image',
}
